import { newRelicJSError } from "../../analytics/new_relic_helper";

export function bingTrackLead() {
    try {
        window.uetq = window.uetq || [];
        window.uetq.push({ 'ec': 'lead', 'ea': 'click', 'el': 'find an advisor' });
    } catch (err) {
        const error = "Error tracking lead form submission for Bing Pixel: " + err;
        newRelicJSError(error);
        console.error(error);
    }
}

